import type { PassphraseVerification } from '@hedepy/common/schemas/routes/octopus/v1/encryption'
import { createContext } from 'react'

import type { AiEncryptionKey } from '@/src/domains/ai/types'

export interface AiSetupContextValue {
  hasAiConsent: boolean
  verification: PassphraseVerification | null | undefined
  encryptionKey: AiEncryptionKey | null
  recoveryKey: string | null
  isSetupDeclined: boolean
  getEncryptionKey: () => Promise<AiEncryptionKey | null>
  submitEncryptionKey: (encryptionKey: AiEncryptionKey) => void
  openSetupDialog: () => void
}

export const AiSetupContext = createContext<AiSetupContextValue>(undefined as unknown as AiSetupContextValue)
